<template>
    <div class="qksm qksm13">
        <h4>十三、预算绩效情况说明</h4>
        <div class="nogap">
            <p><b>（一）预算绩效管理开展及完成情况。</b></p>
            <p v-if="isPdf && num(qksm['支出绩效项目']) == 0">
                本部门没有项目开展预算绩效管理。
            </p>
            <p v-else>
                2020年度，县财政局批复项目支出绩效项目<reason type="integer" classname="qksm integer" name="支出绩效项目" v-model:value="qksm['支出绩效项目']"></reason>项，
                共涉及资金<reason type="money" classname="qksm money " name="支出涉及资金" v-model:value="qksm['支出涉及资金']"></reason>万元。
                根据预算绩效管理要求，{{$store.state.divData.divname}}组织对2020年度
                <reason type="integer" classname="qksm integer" name="开展绩效项目" v-model:value="qksm['开展绩效项目']"></reason>项{{$parent.typeText}}项目支出开展了绩效自评，
                共涉及资金<reason type="money" classname="qksm money " name="开展涉及资金" v-model:value="qksm['开展涉及资金']"></reason>万元，
                占{{$parent.typeText}}项目支出预算
                <span class="hide_pdf">
                    （<reason type="money" classname="qksm money" name="绩效预算" v-model:value="qksm['绩效预算']"></reason>万元）
                </span>
                总额的{{calcRatio(qksm['开展涉及资金'],qksm['绩效预算'])}}。绩效目标完成情况：
                <reason type="textarea" classname="qksm widest" name="绩效目标完成情况" v-model:value="qksm['绩效目标完成情况']"></reason>
            </p>
            <p><b>（二）项目绩效自评结果。</b></p>
            <p v-if="isPdf && num(qksm['自评结果项目']) == 0">
                本部门没有项目开展绩效自评。
            </p>
            <template v-else>
                <p>
                    {{$store.state.divData.divname}}在2020年度{{$parent.typeText}}决算中反映
                    <reason type="textarea" classname="qksm" name="自评结果" v-model:value="qksm['自评结果']" placeholder="“**”、“**”、“**”"></reason>等
                    <reason type="integer" classname="qksm integer" name="自评结果项目" v-model:value="qksm['自评结果项目']"></reason>个项目绩效自评结果。
                </p>
                <template v-for="(item,idx) in num(qksm['自评结果项目'])" :key="idx">
                    <p>{{idx+1}}. <reason type="textarea" style="width:200px;" classname="qksm" :name="'自评项目名'+idx" v-model:value="qksm['自评项目名'+idx]"></reason>项目绩效自评综述：</p>
                    <p>
                        绩效目标：<reason type="textarea" classname="qksm widest" :name="'自评绩效目标'+idx" v-model:value="qksm['自评绩效目标'+idx]"></reason>
                        预算资金安排及使用情况：项目全年预算数为
                        <reason type="money" classname="qksm money" :name="'自评全年'+idx" v-model:value="qksm['自评全年'+idx]"></reason>万元，实际支出
                        <reason type="money" classname="qksm money" :name="'自评实际'+idx" v-model:value="qksm['自评实际'+idx]"></reason>万元，结转
                        <reason type="money" classname="qksm money" :name="'自评结转'+idx" v-model:value="qksm['自评结转'+idx]"></reason>万元，
                        完成年度预算的{{calcRatio(qksm['自评实际'+idx],qksm['自评全年'+idx])}}。通过项目实施，
                        <reason type="textarea" classname="qksm widest" :name="'自评成效'+idx" v-model:value="qksm['自评成效'+idx]" placeholder="取得的成效"></reason>
                        存在的主要问题：
                        <reason type="textarea" classname="qksm widest" :name="'自评问题'+idx" v-model:value="qksm['自评问题'+idx]" placeholder="主要为绩效目标执行中存在的问题、障碍、未完成绩效目标及其原因等"></reason>
                        下一步改进措施：
                        <reason type="textarea" classname="qksm widest" :name="'自评措施'+idx" v-model:value="qksm['自评措施'+idx]" placeholder="如：设置可量化的绩效指标、提高预算编制精准度、健全绩效目标管理与预算安排有机结合的机制等类似的措施"></reason>
                    </p>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm13",
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                if (this.num(this.qksm['支出绩效项目']) > 0 && this.num(this.qksm['支出涉及资金']) <= 0) {
                    this.addOrSet("qksm131", "请检查本页《十三、预算绩效情况说明》，如支出绩效的项目个数大于0，则涉及资金合计数必须大于0。");
                } else if (this.num(this.qksm['支出绩效项目']) == 0 && this.num(this.qksm['支出涉及资金']) != 0) {
                    this.addOrSet("qksm131", "请检查本页《十三、预算绩效情况说明》，如支出绩效的项目个数为0，则涉及资金合计数必须等于0。");
                } else {
                    this.remove("qksm131")
                }
                if (this.num(this.qksm['开展绩效项目']) > 0 && this.num(this.qksm['开展涉及资金']) <= 0) {
                    this.addOrSet("qksm132", "请检查本页《十三、预算绩效情况说明》，如开展绩效自评的项目个数大于0，则涉及资金合计数必须大于0。");
                } else if (this.num(this.qksm['开展绩效项目']) == 0 && this.num(this.qksm['开展涉及资金']) != 0) {
                    this.addOrSet("qksm132", "请检查本页《十三、预算绩效情况说明》，如开展绩效自评的项目个数为0，则涉及资金合计数必须等于0。");
                } else {
                    this.remove("qksm132")
                }

            }
        }
    };
</script>
